// components/Help/HelpPage.js
import React, { useContext, useEffect, useState } from 'react';
import { Container, Card, Button } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb/BreadCrumb';
import HistoryContext from '../../../Components/Hooks/HistoryContext';
import { CarOutlined, FileProtectOutlined, FireOutlined, UserOutlined } from '@ant-design/icons';
import VehicleHelp from './component/vehicleHelp';
import DriverHelp from './component/driverHelp';
import InspectionHelp from './component/inspectionsHelp';
import CatalogHelp from './component/catalogHelp';

const HelpPage = () => {
  const history = useContext(HistoryContext);
  useEffect(() => {
    document.title = `Aide | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  }, []);
  const [activeTab, setActiveTab] = useState('vehicles');

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'vehicles':
        return <VehicleHelp />;
      case 'inspections':
        return <InspectionHelp />;
      case 'status':
        return <CatalogHelp />;
      case 'drivers':
        return <DriverHelp />;
      default:
        return null;
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb page="Aide" history={history} />
        <div className="help-page">
          <h1 className="hstack text-nowrap gap-2" style={{ backgroundColor: '#eddfc7', color: '#000', fontSize: '1.1rem', fontWeight: 'bold', padding: '5px 10px', borderRadius: '5px', display: 'inline-block' }}>
            AIDE ET SUPPORT 🤗
          </h1>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="d-flex gap-3 flex-nowrap">
              <Button onClick={() => handleTabChange('vehicles')} className={`btn ${activeTab === 'vehicles' ? 'active-tab' : 'btn-light'}`}>
                Véhicules {<CarOutlined />}
              </Button>
              <Button onClick={() => handleTabChange('inspections')} className={`btn ${activeTab === 'inspections' ? 'active-tab' : 'btn-light'}`}>
                Inspections {<FileProtectOutlined />}
              </Button>
              <Button onClick={() => handleTabChange('status')} className={`btn ${activeTab === 'status' ? 'active-tab' : 'btn-light'}`}>
                Status {<FireOutlined />}
              </Button>
              <Button onClick={() => handleTabChange('drivers')} className={`btn ${activeTab === 'drivers' ? 'active-tab' : 'btn-light'}`}>
                Chauffeurs {<UserOutlined />}
              </Button>
            </div>
          </div>
          <Card>
            <div style={{ padding: '20px' }}>
              {renderActiveTab()}
            </div>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default HelpPage;
